import Logger from '../../utils/logger/logger';
import BasePage from '../../components/base-page/base-page';

import './truth-about-ukraine.scss';

class TruthAboutUkrainePage extends BasePage {
  onInit() {
    Logger.initialize();
  }
}
export default TruthAboutUkrainePage;

TruthAboutUkrainePage.initOnDomLoaded();

